var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4864 1C3.00868 1 1 3.00868 1 5.4864C1 9.97279 6.3021 14.0513 9.15708 15C12.0121 14.0513 17.3142 9.97279 17.3142 5.4864C17.3142 3.00868 15.3055 1 12.8278 1C11.3106 1 9.96871 1.75331 9.15708 2.90631C8.74339 2.31705 8.1938 1.83614 7.55484 1.50431C6.91589 1.17248 6.20638 0.999492 5.4864 1Z",
    stroke: "#1F2F3D",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLikeIcon);
export default __webpack_public_path__ + "static/media/insta-like-icon.67a33e8b91eae4b683c2bc6b30bed1e8.svg";
export { ForwardRef as ReactComponent };